module.exports = __webpack_public_path__ + "img/near-5.cfb5ed40.jpg";